import { BaseFilterOption } from '../types';
import { IndividualInSilicoPredictors } from '../../components';

export const config: BaseFilterOption = {
  id: 'omicsExplorer.filters.individualInSilicoPredictors',
  title: {
    id: 'omicsExplorer.filters.individualInSilicoPredictors',
    defaultMessage: 'Individual In Silico Predictors',
  },
  content: IndividualInSilicoPredictors,
};
